module.exports = "/_next/static/images/DiagnoseDataQualityIssues@2x-39fb43fba9a5f7e03187a6b389436f2d.webp";